import React, { forwardRef } from "react";
import { TextField, Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiInputBase-input::placeholder": {
    opacity: 0.7,
  },
}));

const LimitedTextField = forwardRef(
  (
    {
      name,
      label,
      value = "",
      onChange,
      maxLength,
      error = false,
      errorText = "This field is required",
      placeholder,
      multiline = false,
      rows = 1,
      width = "25ch",
      ...props
    },
    ref,
  ) => {
    const remainingChars = maxLength - (value?.length ?? 0);
    const isAtLimit = remainingChars === 0;
    const helperText = error
      ? errorText
      : maxLength
        ? `${remainingChars} characters remaining`
        : undefined;

    return (
      <Box sx={{ mb: 2, width: "100%" }}>
        <StyledTextField
          id={name}
          name={name}
          label={label}
          value={value || ""}
          onChange={onChange}
          variant="standard"
          error={error || isAtLimit}
          helperText={helperText}
          placeholder={placeholder}
          multiline={multiline}
          rows={rows}
          fullWidth
          slotProps={{
            input: {
              maxLength: maxLength,
            },
          }}
          {...props}
          inputRef={ref}
        />
      </Box>
    );
  },
);

export default LimitedTextField;
